import * as Sentry from "@sentry/react";

/**
 * Check if current location matches a step's route (supports query params).
 * Extra query params in the current location are intentionally allowed —
 * the route specifies required params, and the page may have additional params
 * from other features (e.g., date filters, search state).
 */
export function isOnRoute(location: { pathname: string; search: string }, route: string): boolean {
    let url: URL;
    try {
        url = new URL(route, window.location.origin);
    } catch (e) {
        console.error(`[Tours] Invalid route URL: "${route}"`, e);
        Sentry.captureMessage(`Invalid tour route URL: "${route}"`, {
            level: "error",
            extra: { route, error: e instanceof Error ? e.message : String(e) },
        });
        return false;
    }
    if (location.pathname !== url.pathname) return false;
    if (!url.search) return true;

    const currentParams = new URLSearchParams(location.search);
    return Array.from(url.searchParams.entries()).every(([key, value]) => currentParams.get(key) === value);
}
